
// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { fetchOrdersApi } from "../../service/order/orderService";

// interface Order {
//   id: number | string;
//   orderId: string;
//   createdAt: string;
//   name: string;
//   paymentMethod: string;
//   total: number;
//   status: string;
// }
// interface OrdersState {
//   data: Order[];
//   loading: boolean;
//   error: string | null;
//   totalDoc: number;
//   limits: number;
//   currentPage: number;
// }

// const initialState: OrdersState = {
//   data: [],
//   loading: false,
//   error: null,
//   totalDoc: 0,
//   limits: 10,
//   currentPage: 1,
// };


// export const fetchOrders = createAsyncThunk(
//   "orders/fetchOrders",
//   async (filters: any, { rejectWithValue }) => {
//     try {
//       const response = await fetchOrdersApi(filters);
//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(
//         error.response?.data?.message || error.message || "Something went wrong"
//       );
//     }
//   }
// );
// const ordersSlice = createSlice({
//   name: "orders",
//   initialState,
//   reducers: {
//     setCurrentPage: (state, action) => {
//       state.currentPage = action.payload;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchOrders.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchOrders.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = action.payload.orders;
//         state.totalDoc = action.payload.totalDoc;
//         state.limits = action.payload.limits;
//         state.currentPage = action.payload.currentPage;
//       })
//       .addCase(fetchOrders.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || "Failed to fetch orders";
//       });
//   },
// });

// export const { setCurrentPage } = ordersSlice.actions;

// export default ordersSlice.reducer;



import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OrderState {
  selectedOrderDetails: any | null;
  cartDetails: any;
}

const initialState: OrderState = {
  selectedOrderDetails: null,
  cartDetails: null
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setOrderDetails(state, action: PayloadAction<any>) {
      state.selectedOrderDetails = action.payload;
    },
    setCartDetails(state, action: PayloadAction<any>) {
      state.cartDetails = action.payload;
    },
    clearOrderDetails(state) {
      state.selectedOrderDetails = null;
    },
    clearCartDetails(state) {
      state.cartDetails = null;
    }
  }
});

export const { setOrderDetails, clearOrderDetails, setCartDetails } = orderSlice.actions;
export default orderSlice.reducer;